import AdvancedEditor from "./novel/components/advanced-editor";

export default function ReadOnlyEditor({ value }: any) {

  return (
    <div className="text-justify novel-editor-readonly">
      <AdvancedEditor value={value} readOnly={true}/>
    </div>
  );
}
